export const getGeolocation = () => {
  return new Promise(async (resolve) => {
    try {
      if (!navigator.geolocation)
        throw new Error("Geolocation is not supported by your browser.");
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
      const { latitude, longitude } = position.coords;
      resolve({ latitude, longitude });
    } catch (err) {
      console.error(`Geolocation error: ${err.message}`);
      resolve({ latitude: null, longitude: null });
    }
  });
};
